import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
	AlertDialogTrigger,
} from '@/common/ui/alert-dialog'
import { Button } from '@/common/ui/button'
import { Trash2 } from 'lucide-react'
import { toast } from 'sonner'
import { useQueryClient } from '@tanstack/react-query'

import useMutationDeleteBatch from '@/modules/batches/api/hooks/useMutationDeleteBatch'
import { BatchesQueryKeys } from '@/modules/batches/keys'
import showErrorToast from '@/common/utils/showErrorToast'

interface DeleteBatchProps {
	id: string
}

export default function DeleteBatch({ id }: DeleteBatchProps) {
	const queryClient = useQueryClient()
	const { mutate: deleteBatch } = useMutationDeleteBatch({
		onSuccess: () => {
			toast.success('ลบชุดคูปองสำเร็จ')
			queryClient.invalidateQueries({
				queryKey: [BatchesQueryKeys.GetBatches],
			})
		},
		onError: (error) => {
			showErrorToast(error)
		},
	})

	const handleDelete = () => {
		deleteBatch(id)
	}

	return (
		<AlertDialog>
			<AlertDialogTrigger asChild>
				<Button variant="ghost" size="icon">
					<Trash2 className="h-4 w-4 text-destructive" />
				</Button>
			</AlertDialogTrigger>
			<AlertDialogContent>
				<AlertDialogHeader>
					<AlertDialogTitle>ยืนยันการลบชุดคูปอง</AlertDialogTitle>
					<AlertDialogDescription>
						การกระทำนี้ไม่สามารถย้อนกลับได้
						ชุดคูปองนี้จะถูกลบออกจากระบบอย่างถาวร
					</AlertDialogDescription>
				</AlertDialogHeader>
				<AlertDialogFooter>
					<AlertDialogCancel>ยกเลิก</AlertDialogCancel>
					<AlertDialogAction onClick={handleDelete}>ลบ</AlertDialogAction>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	)
}
